import { MODULE_TRANSLATION_ALLOWLIST } from './module-allowlist';
export const UR_LATN_KEPT_ENGLISH = ['MRN', 'VAT', 'OPD', 'IPD', 'NTN', 'TRN', 'NIT', 'Token', 'Invoice', 'Pharmacy', 'Laboratory', 'Radiology', 'Billing', 'Dashboard', 'Settings', 'Password', 'Email', 'Card', 'Cheque'];
export const UR_LATN_DOSING_WORDS = {
    'once a day': 'din mein aik baar',
    'twice a day': 'din mein do baar',
    'three times a day': 'din mein teen baar',
    'four times a day': 'din mein chaar baar',
    'at night': 'raat ko',
    'in the morning': 'subah',
    'before meals': 'khane se pehle',
    'after meals': 'khane ke baad',
    'when needed': 'zaroorat par',
    tablet: 'goli',
    tablets: 'goliyan',
    capsule: 'capsule',
    spoon: 'chamach',
    drops: 'qatre',
    days: 'din',
};
const CORE_TRANSLATION_ALLOWLIST = {
    ar: ['common:state.none', 'common:language.name.en', 'common:language.name.ar', 'common:language.name.es', 'common:language.name.ur-Latn'],
    es: [
        'common:state.none',
        'common:field.total',
        'common:no',
        'common:language.name.en',
        'common:language.name.ar',
        'common:language.name.es',
        'common:language.name.ur-Latn',
        'enum:payment_mode.cheque',
        'enum:patient_category.vip',
        'enum:lab_flag.normal',
        'settings:tab.general',
        'print:title.prefactura',
        'print:label.total',
        'print:label.nit',
    ],
    'ur-Latn': [
        'common:state.none',
        'common:field.code',
        'common:field.status',
        'common:field.notes',
        'common:field.phone',
        'common:field.email',
        'common:field.currency',
        'common:field.branch',
        'common:language.name.en',
        'common:language.name.ur-Latn',
        'enum:payment_mode.card',
        'enum:payment_mode.bank_transfer',
        'enum:payment_mode.mobile_wallet',
        'enum:payment_mode.cheque',
        'enum:patient_category.panel',
        'enum:patient_category.insurance',
        'enum:patient_category.staff',
        'enum:patient_category.vip',
        'enum:appointment_status.booked',
        'enum:invoice_context.opd',
        'enum:invoice_context.ipd',
        'enum:invoice_context.pharmacy',
        'enum:invoice_context.lab',
        'enum:invoice_context.radiology',
        'print:title.invoice',
        'print:title.tax_invoice',
        'print:title.simplified_tax_invoice',
        'print:title.credit_note',
        'print:title.tax_credit_note',
        'print:title.simplified_tax_credit_note',
        'print:title.refund_voucher',
        'print:title.prefactura',
        'print:label.invoice_no',
        'print:label.mrn',
        'print:lab.mrn',
        'print:label.rate',
        'print:label.vat',
        'print:label.vat_rate',
        'print:label.vat_number',
        'print:label.cr_number',
        'print:label.trn',
        'print:label.company_number',
        'print:label.ntn',
        'print:label.nit',
        'print:label.cashier',
        'print:label.invoice',
        'shell:nav.dashboard',
        'shell:nav.item.dashboard',
        'shell:nav.item.appointments',
        'shell:nav.item.lab',
        'shell:nav.item.radiology',
        'shell:nav.item.billing',
        'shell:nav.item.admin.settings',
        'shell:nav.appointments',
        'shell:nav.opd',
        'shell:nav.ipd',
        'shell:nav.billing',
        'shell:nav.pharmacy',
        'shell:nav.lab',
        'shell:nav.radiology',
        'shell:nav.accounts',
        'shell:nav.reports',
        'shell:nav.settings',
        'shell:menu.sign_out',
        'shell:branch.label',
        'auth:signin.title',
        'auth:signin.password',
        'auth:signin.code',
        'auth:signin.submit',
        'auth:security.password_title',
        'portal:signin.phone',
        'portal:signin.code',
        'portal:signin.verify',
        'portal:kiosk.check_in',
        'queue:token',
        'queue:doctor',
        'settings:title',
        'settings:tab.numbering',
        'settings:tab.laboratory',
        'settings:tab.integrations',
        'settings:tax.title',
        'settings:tax.registration_number',
        'settings:tax.company_number',
        'settings:branch.currency',
        'patients:identity.document',
        'patients:identity.number',
        'patients:identity.expiry',
        'queue:counter',
    ],
};
export const TRANSLATION_ALLOWLIST = Object.fromEntries(Object.entries(CORE_TRANSLATION_ALLOWLIST).map(([locale, entries]) => [locale, new Set([...entries, ...(MODULE_TRANSLATION_ALLOWLIST[locale] ?? [])])]));
//# sourceMappingURL=glossary.js.map